export default __webpack_public_path__ + "static/media/servers.5ac57df6.png";